    <div *ngIf="!test">
      <div style="padding-bottom: 20px;"> 

              <mat-card class="example-card card_nopadding">
                <mat-card-header class="header_card">
             
                </mat-card-header>
                <mat-card-content class="card_content">    
                  <div class="cargando"><mat-spinner *ngIf="cargandoCard"></mat-spinner></div>   
                  <div *ngIf="!verCertificado">
                    <p style="text-align: justify;">
                      A continuación le invitamos a responder una evaluación de aprendizaje sobre los contenidos del Modelo de Gestión de Calidad de la Educación Parvularia. 
                      <br><br>La prueba consta de 16 preguntas, las que son seleccionadas aleatoriamente dentro de un set mayor de preguntas. Para ser aprobada, debe responder correctivamente -al menos- el 75% de ellas (12 preguntas), para conseguirlo dispondrá de hasta 3 intentos. 
                      Si luego de los 3 intentos no logra aprobar, obtendrá un Certificado de Participación.
                      <br><br>
                    </p>
                    <mat-grid-list cols="2" class="grid_padding">
                      <mat-grid-tile class="grid_padding_top">
                        <button mat-raised-button class="btn_video_left" (click)="verResumenIntentos()" [disabled]='cantidadIntentos === 0'>
                          Resumen Intentos
                        </button>
                      </mat-grid-tile>
                      <mat-grid-tile class="grid_padding_top">
                        <button mat-raised-button class="btn_video" (click)="comenzarEvaluacion()" [disabled]='cantidadIntentos === 3'>
                          Comenzar Evaluación
                          <span class="material-icons">outlined_flag</span>
                        </button>
                         <p class="info-intentos">Queda(n) {{3 - cantidadIntentos}} intento(s)</p> 
                      </mat-grid-tile>
                    </mat-grid-list>   
                  </div>     
                  <div *ngIf="verCertificado">
                    <iframe  src="data:application/pdf;base64" id="certificado" style="height: 700px;width: 100%;"></iframe>                    
                  </div>              
                </mat-card-content>
              </mat-card>
     
      </div>  
    </div>

    <div *ngIf="test">
      <div class="cargando"><mat-spinner *ngIf="cargando"></mat-spinner></div>
      <div *ngIf="!cargando"> 
        <p>
          A continuación se mostrarán <b>UNA A UNA</b> las preguntas de la evaluación. 
          Revise su respuesta antes de presionar el botón siguiente, ya que <b>no podrá volver atrás</b>. 
          Considere que si cierra la evaluación antes de responder la pregunta final, se tomará como un intento y se restará de los 3 con los que cuenta.
        </p>

        <mat-horizontal-stepper linear #stepper class="stepper-evaluacion" (selectionChange)="changeStep($event)">
          <mat-step *ngFor="let pregunta of evaluacion; let i = index">
            <div class="card-preguntas">
              <div class="evaluacion-set">
                <div class="evaluacion-form-content">
                  <div class="numero-estado">
                    <span>{{i+1}}</span>
                  </div>
                  <div class="cabecera">
                    <h3 [innerHTML]="pregunta.pregunta"></h3>
                  </div>
                  <div class="form-interior">
                    <mat-radio-group required
                        aria-labelledby="example-radio-group-label"
                        class="example-radio-group">
                        <mat-radio-button (click)="alternativaSeleccionada(a,i)" class="example-radio-button" 
                        *ngFor="let alternativa of pregunta.alternativas; let a = index" [value]="alternativa.idAlternativa">
                          {{alternativa.mensaje}}
                        </mat-radio-button>
                      </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>
          </mat-step>
        </mat-horizontal-stepper>

        <div class="div-btn-siguiente">
          <button mat-raised-button (click)="siguiente(stepper)" type="button" class="btn-siguiente btn-send" *ngIf="!finalizarEvaluacion" [disabled]="!opcionSiguiente">
            Siguiente
          </button>
          <button mat-raised-button  (click)="enviarEvaluacion()" type="button" class="btn-siguiente btn-send" *ngIf="finalizarEvaluacion" [disabled]="!opcionSiguiente">
            Finalizar
          </button>
          <!-- <button mat-button (click)="stepper.reset()">Reset</button>-->
        </div>  
      </div>   
    </div>